import { Content } from "pdfmake/interfaces";

import { ObservationSummaryWithUser } from "@intocare/data-access/portal/care";

import { DocumentContext } from "./document-context";
import { observationToDisplay, shortTime } from "./utils";

type HeaderObservation = Pick<
	ObservationSummaryWithUser,
	"createdOn" | "createdBy" | "observationSubType" | "observationType" | "occurredOn"
>;

export const observationReportHeader = (ctx: DocumentContext, observation: HeaderObservation): Content => {
	const creationDate = new Date(observation.createdOn);

	const topHeaderText = ctx.t("features/pdf-generation.header.topHeader", {
		creator: observation.createdBy.label,
		creationDate: creationDate.toLocaleDateString(ctx.locale),
		creationTime: creationDate.toLocaleTimeString(ctx.locale, shortTime),
	});

	const observationTitle = `${observationToDisplay
		.type(observation.observationSubType ?? observation.observationType, ctx.locale)
		.toLocaleUpperCase()} ${observationToDisplay.occurredOn(observation.occurredOn, ctx.locale)}`;

	return reportHeader({
		title: ctx.t("features/pdf-generation.header.title"),
		subTitle: observationTitle,
		topHeader: topHeaderText,
	});
};

export const reportHeader = (content: { title: string; subTitle: string; topHeader: string }): Content => {
	return {
		stack: [
			{ text: content.title, style: { bold: true } },
			{ text: content.subTitle, style: "header" },
			{ text: content.topHeader, style: "topHeader" },
		],
	};
};
